import { useMemo } from 'react';
import { ChartType } from '@dbl/core/chart';
import {checkIsChartDataNull} from "@/pages/datalab/pages/Multidimensional/Analysis/components/AnalysisLineChart";

export function useNoTableData(props: any) {
  const { table, chartType, chartData } = props;
  const noData = useMemo(() => {
    
    switch (chartType) {
      case ChartType.Table: {
        return !table?.actualCount;
      }
      case ChartType.StackBar: {
        // [legacy · 重构可删] chartData.axisList 对应已废弃的 wire axis_list
        return checkIsChartDataNull(chartData?.stackCharts) || checkIsChartDataNull(chartData?.axisList);
      }
      case ChartType.Bar: {
        return checkIsChartDataNull(chartData?.barChart?.seriesData);
      }
      case ChartType.Line: {
        return checkIsChartDataNull(chartData?.lineChart?.seriesData);
      }
      case ChartType.MixedChart: {
        return checkIsChartDataNull(chartData?.mixedChartData);
      }
      case ChartType.EventLine: {
        return checkIsChartDataNull(chartData?.eventLineChart?.seriesData);
      }
      case ChartType.Pie: {
        return checkIsChartDataNull(chartData?.pieChartData);
      }
      case ChartType.BigNumber: {
        return !chartData.trend_metric.value;
      }
      case ChartType.Trend: {
        return checkIsChartDataNull(chartData.lineData);
      }
      case ChartType.DimNumberTrend: {
        return checkIsChartDataNull(chartData?.lineData) || checkIsChartDataNull(chartData.rankData);
      }
      default: return true;
    }
    
  }, [chartData]);
  return noData;
}
